import { modalRenderer } from '~/modal/modalRendererRegistry';
import { ContactUsModalComponent } from './contactUsModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ContactUs: undefined;
  }
}
modalRenderer.register('ContactUs', ContactUsModalComponent);
